import { ServerError } from '@apollo/client/errors'

// Using `console` to avoid pulling winston (~393 kB with Node polyfills) into
// the client bundle: this module is imported by page files that also ship
// client code, so the whole import chain ends up in the browser bundle.
const logger = console

export enum HygraphErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  NotFound = 404,
  TooManyRequests = 429,
  InternalServerError = 500
}

export function processHygraphRequestError(
  error: unknown,
  message: string
): { code: HygraphErrorCode | undefined } {
  logger.error(message, { error })

  // AC4: ServerError is thrown directly, not wrapped in { networkError: ... }
  const statusCode = ServerError.is(error) ? error.statusCode : undefined

  if (statusCode === HygraphErrorCode.NotFound) {
    throw new Error(`Network Error: ${message} - Not Found`)
  }

  if (statusCode === HygraphErrorCode.InternalServerError) {
    throw new Error(message)
  }

  return { code: statusCode }
}
